import React, {
  createRef,
  FunctionComponent,
  useMemo,
  useState,
  useEffect,
  useRef,
} from 'react';
import {
  Button,
  Form,
  Card,
  DropdownButton,
  Dropdown,
  FormControl,
  FormGroup,
  InputGroup,
} from 'react-bootstrap';
import { Redirect } from 'react-router-dom';
import { connect, ConnectedProps } from 'react-redux';
import { ErrorModal } from '../components';
import { AuthDispatches, ErrorDispatches } from '../redux/Dispatches';
import { ApplicationState } from '../redux/States';
import loginLogo from '../assets/images/login/logo01.png';
import apis from '../apis';

const mapState = (state: ApplicationState) => ({
  ...state.auth,
  ...state.error,
});
const mapDispatch = { ...AuthDispatches, ...ErrorDispatches };
const connector = connect(mapState, mapDispatch);
type Props = ConnectedProps<typeof connector>;

const DEVICE_CHANGED = '檢測到設備轉移，請重新進行 OTP 驗證';
const OTP_EXPIRED = '距離上次驗證已超過7天，請重新進行 OTP 驗證';

const otpPage: FunctionComponent<Props> = ({
  isAuth,
  user,
  updateAuth,
  signOut,
  catchErrorForModal,
}) => {
  if (!isAuth) return <></>;
  if (user.currentSchool) return <Redirect to="/" />;

  const [schoolId, setSchoolId] = useState<string>(
    Object.values(user.schools)[0]?.id || ''
  );
  const [otp, setOTP] = useState<string>('');
  const [cooldown, setCooldown] = useState<number>(0);
  const cooldownRef = useRef<NodeJS.Timeout | null>(null);
  // const reason = useMemo(() => {
  //   user.
  // }, []);

  const sendOtp = () => {
    console.log('send OTP to school', schoolId);
    if (!schoolId) return;
    setCooldown(180);
    cooldownRef.current = setInterval(() => {
      setCooldown((prev) => {
        if (prev <= 1) {
          clearInterval(cooldownRef.current!);
          cooldownRef.current = null;
          setCooldown(0);
        }
        return prev - 1;
      });
    }, 1000);
    apis
      .sendOTPCode(schoolId)
      .then((res) => {
        if (res) {
          updateAuth(res);
          clearInterval(cooldownRef.current!);
          setCooldown(0);
        }
      })
      .catch(catchErrorForModal);
  };

  const verifyOtp = () => {
    if (!schoolId || !otp) return;
    apis
      .verifyOTPCode(schoolId, otp)
      .then((res) => {
        updateAuth(res);
        clearInterval(cooldownRef.current!);
      })
      .catch(catchErrorForModal);
  };

  document.title = '學生健康資訊系統';

  return (
    <React.Fragment>
      <div className="auth-wrapper">
        <div className="auth-content">
          <div className="auth-bg">
            <span className="r" />
            <span className="r s" />
            <span className="r s" />
            <span className="r" />
          </div>
          <Card className="borderless text-center">
            <Card.Body>
              <img
                src={loginLogo}
                alt="icon"
                style={{ width: '250px', height: 'auto', marginBottom: '16px' }}
              />
              <p className="text-left">
                <b>{DEVICE_CHANGED}</b>
              </p>
              <p>
                請選擇登入學校後到電子郵箱 <b>{maskEmail(user.mail)}</b> 獲取
                OTP 驗證碼
              </p>
              <InputGroup className="mb-3 justify-content-center">
                <InputGroup.Prepend>
                  <DropdownButton
                    variant="outline-primary"
                    title={
                      (schoolId &&
                        user?.schools[schoolId] &&
                        user?.schools[schoolId].name) ||
                      '請先選擇學校'
                    }
                    className="mb-3"
                    onSelect={(k: string | null) => {
                      if (k == null || !user?.schools[k]) return;
                      setSchoolId(k);
                    }}
                  >
                    {Object.entries(user?.schools || {}).map(([i, n]) => (
                      <Dropdown.Item key={`class-${i}`} eventKey={i}>
                        {n.name}
                      </Dropdown.Item>
                    ))}
                  </DropdownButton>
                </InputGroup.Prepend>
                <InputGroup.Append>
                  <Button
                    className="mb-3"
                    onClick={sendOtp}
                    disabled={!schoolId || cooldownRef.current !== null}
                  >
                    {cooldownRef.current
                      ? `已發送(${cooldown}秒后可重送)`
                      : '發送驗證碼'}
                  </Button>
                </InputGroup.Append>
              </InputGroup>
              <InputGroup className="mb-3">
                <FormControl
                  type="text"
                  value={otp}
                  placeholder="請輸入 OTP 驗證碼"
                  onChange={(e) => {
                    setOTP(e.target.value);
                    if (e.target.value.length >= 6) {
                      // changeSchool(schoolId, e.target.value).catch(
                      //   catchErrorForModal
                      // );
                    }
                  }}
                />
                <InputGroup.Append>
                  <Button
                    onClick={verifyOtp}
                    disabled={otp.length < 6 || !schoolId}
                  >
                    驗證
                  </Button>
                </InputGroup.Append>
              </InputGroup>
              <Button
                variant="secondary"
                onClick={() => signOut().catch(() => {})}
              >
                返回到登入頁面
              </Button>
            </Card.Body>
          </Card>
        </div>
      </div>
      <ErrorModal />
    </React.Fragment>
  );
};

export const OTPPage = connector(otpPage);

function maskEmail(email?: string): string {
  if (!email) return '';
  const parts = email.split('@');
  if (parts.length !== 2) return email;
  const name = parts[0];
  const domain = parts[1].split('.').shift() || '';
  const tld = parts[1].split('.').pop() || '';
  return `${name.charAt(0)}*****@${domain.charAt(0)}***.${tld}`;
}
